import ReportViewWrapper from './ReportViewWrapper'

export default ReportViewWrapper
